import React from 'react'

export const DefaultLayout: React.FunctionComponent = (props) => {
  return <div className="container">{props.children}</div>
}
